import React from 'react'

export const TableUnstyled = ({ children, ...otherProps }) => (
  <table {...otherProps}>{children}</table>
)



// WEBPACK FOOTER //
// ./src/Components/Table/unstyled.js